import {Component, Input} from '@angular/core';

import { Denuncia } from '../denuncia/denuncia';
import { DenunciaService } from '../denuncia/denuncia.service';

import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';

import { Entrevista } from '../entrevistas/entrevista';
import { EntrevistaService } from '../entrevistas/entrevista.service';

import { Router, ActivatedRoute, Params } from '@angular/router';


@Component({
  selector: 'app-modal-encam-psic',
  template: `
  <div id="modalencp" (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal();">&times;</button>
        <h4 class="modal-title">Encaminhamento Psicológico</h4>
          <ng-content select=".app-modal-header"></ng-content>
        </div>
        <form id="login-form">
        <div class="modal-body">
            <p><label for="Nome">Nome da pessoa encaminhada:</label>
            {{this.entrevista.nome}}</p>
            <p><label for="Email">E-mail da pessoa encaminhada:</label>
            {{this.entrevista.email}}</p>
            <p><label for="Telefone">Telefone da pessoa encaminhada:</label>
            {{this.entrevista.telefone}}</p>
            <p><label for="Perfil">Perfil da pessoa encaminhada:</label>
            {{this.entrevista.listaPerfisEntrev}}</p>
            <p style="color: red;">A pessoa acima será encaminhada para o departamento psicológico. Para confirmar o encaminhamento, clique no botão logo abaixo.</p>
            <ng-content select=".app-modal-body"></ng-content>
        </div>
        <div class="modal-footer">
            <div class="col-sm-offset-2 col-sm-10">
            <!--a href="javascript:window.print()" class="btn btn-default btn-xs"><i class="glyphicon glyphicon-print"></i><br/>imprimir esta página</a-->
            <button type="button" class="btn btn-default" (click)="closeModal();">Fechar</button>
            <button class="btn btn-success" (click)="salvarEncaminhamentoPsicologico();" data-dismiss="modalr">Confirmar encaminhamento</button>
            </div>
          <ng-content select=".app-modal-footer"></ng-content>
        </div>
        </form>
      </div>
    </div>
  </div>
  `,
  styles: [`
    .modal {
      background: rgba(0,0,0,0.6);
    }
  `],
  providers: [
    DenunciaService,
    IncidenteService,
    EntrevistaService
  ]
})
export class ModalEncaminhamentoPsicologicoComponent {

  public visible = false;
  private visibleAnimate = false;

  denuncia: Denuncia;

  incidente: Incidente;

  entrevista: Entrevista;

  descricaoencam: string;

  nomeencam: string;

  @Input() desc:string;
  @Input() nome:string;
  @Input() idInc: number;
  @Input() idEntrev: number;

  constructor(private denService: DenunciaService, private incidenteService: IncidenteService, private entrevistaService: EntrevistaService, private router: Router) {
    this.entrevista = new Entrevista();
  }

  public getDadosEntrevista(id): void {
    //console.log("id entrevista = " + id);
    if (id !== undefined) {
      this.entrevistaService.getDadosEntrevista(id)
        .then((entrevista) => {this.entrevista = entrevista;});
    }

  }

  public show(id,idEnt): void {

    //console.log("id incidente " + id + ", id entrevista " + idEnt);

    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);

    this.idInc = id; // id do incidente
    this.idEntrev = idEnt; // id da entrevista

    this.getDadosEntrevista(idEnt);

    //console.log("Dados entrevista: " + this.entrevista);

  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public closeModal(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  public salvarEncaminhamentoPsicologico(): void {
    this.incidente = new Incidente;

    // definindo o id do incidente e os dados do encaminhamento
    //this.incidente.descricaoencam = this.desc;
    //this.incidente.nomeencam = this.nome;
    this.incidente.id = this.idInc;
    this.incidente.encaminhado = true;
    this.incidente.flagPsicologico = true;
    this.incidente.idEntrevista = this.idEntrev;

    //console.log(this.incidente);

    this.incidenteService.salvarEncaminhamento(this.incidente)
        .then((resposta) => this.goBack(resposta))

    // fecha a janela modal
    this.hide();

  }

  goBack(resposta: any): void {
     alert(resposta);
     window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/denuncias/modalencaminhamentopsicologico.component.ts